import {registerAPIService} from './APIServicesRegistry';
import APIServiceBase from './APIServiceBase';

export default class TranslationApiService extends APIServiceBase {
    constructor() {
        super('Translation')
    }

    addMissingTranslationKey(data: any) {
        return this.post('AddMissingTranslationKey', data)
    }
}

registerAPIService(TranslationApiService)